export default __webpack_public_path__ + "static/result_back-6bb55682ab3e209d92486b50479e6c9b.webp";